import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ContestShowPage from '@buyside/components/presentation/ContestShowPage/contestShowPage';

import { contestsUrl } from '@buyside/util/urlHelper';

const ContestShowPageRoot: FC<{ contestId: string; isMember: string }> = ({
  contestId,
  isMember
}) => {
  if (!contestId) return;

  return (
    <Router basename={contestsUrl() + contestId}>
      <ContestShowPage contestId={contestId} isPublic={!(isMember === 'true')} />
    </Router>
  );
};

export default ContestShowPageRoot;
